import { useLocation } from 'react-router-dom'
import { Main } from '../pages/main'
import { WbDtuPage } from './WbDtuPage'

// YM uses UUID order IDs. WB DTU uses a separate 256-bit capability namespace.
// A missing WB order must never fall through to YM's fulfillment handlers.
export function redemptionTarget(search) {
  const params = new URLSearchParams(search)
  const orders = params.getAll('order'), aliases = params.getAll('wbDtu')
  if (aliases.length || orders.some(value => /^[a-f0-9]{64}$/.test(value))) {
    const ids = [...orders, ...aliases]
    const token = ids[0] || ''
    return { type: 'wb', token: ids.every(value => value === token) && orders.length <= 1 && aliases.length <= 1 ? token : '' }
  }
  return { type: 'ym' }
}

export function RedemptionEntry() {
  const { search } = useLocation()
  const target = redemptionTarget(search)
  return target.type === 'wb' ? <WbDtuPage key={target.token} token={target.token} /> : <Main />
}
